<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@for (slot of slots; let i = $index; track i) {
  @if (!slot.hidden) {
    <render-slice-slot
      data-e2e="render-slice-slot"
      class="slot"
      [slice]="slice"
      [slot]="(i + 1).toString()"
      [ngStyle]="getSlotStyles(slot)">
    </render-slice-slot>
  }
}
